import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/esm/taggedTemplateLiteralLoose";

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n\t\t", " & {\n\t\t\t", "\n\t\t}\n\t"]);

  _templateObject = function () {
    return data;
  };

  return data;
}

import { DARK_MODE_ATTR } from '@wp-g2/create-styles';
import { css } from '../style-system';
/**
 * @param {TemplateStringsArray} strings
 * @param  {import('create-emotion').Interpolation[]} interpolations
 */

export function darkMode(strings) {
  for (var _len = arguments.length, interpolations = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    interpolations[_key - 1] = arguments[_key];
  }

  var interpolatedStyles = css.apply(void 0, [strings].concat(interpolations));
  return css(_templateObject(), DARK_MODE_ATTR, interpolatedStyles);
}